module.exports = __webpack_public_path__ + "static/media/jt6.002ddebd.png";